import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { useState } from 'react';
import './tooltip.scss';

type TooltipProps = {
    tooltipLeft?: boolean;
    tooltipBottomCenter?: boolean;
    tooltipTopCenter?: boolean;
    content?: any;
    stringContent?: string;
    title?: string;
};

const Tooltip = ({
    tooltipLeft = false,
    tooltipBottomCenter = false,
    tooltipTopCenter = false,
    content,
    stringContent,
    title,
}: TooltipProps) => {
    const [isActive, setActive] = useState(false);

    const isJSON = (str: string) => {
        try {
            JSON.parse(str);
            return true;
        } catch (e) {
            return false;
        }
    };

    const renderContent = (content: any) => {
        if (!content) return null;

        if (typeof content === 'string') {
            return isJSON(content)
                ? documentToReactComponents(JSON.parse(content))
                : null;
        }
        return documentToReactComponents(content);
    };

    return (
        <div
            className="a-tooltip-element--tooltip"
            data-testid="tooltip-element"
        >
            <i
                data-testid="tooltip-icon"
                className="icon icon-question-circle"
                onClick={() => setActive(true)}
            />
            <div>
                <span
                    data-testid="tooltip-text"
                    className={`a-tooltip-element--tooltip__text 
            ${tooltipLeft ? 'a-tooltip-element--tooltip__text--left' : ''}
            ${
                tooltipTopCenter
                    ? 'a-tooltip-element--tooltip__text--bottom-center a-tooltip-element--tooltip__text--bottom-center__top-mobile'
                    : ''
            }
            ${
                tooltipBottomCenter
                    ? 'a-tooltip-element--tooltip__text--bottom-center'
                    : ''
            } 
            ${!isActive ? 'a-tooltip-element--tooltip__text--inactive' : ''}`}
                >
                    <button
                        className={'a-tooltip-element__close'}
                        onClick={() => setActive(false)}
                    >
                        <span className={'a-tooltip-element__line'}></span>
                        <span className={'a-tooltip-element__line'}></span>
                    </button>
                    {title && (
                        <h3 className={'a-tooltip-element__title'}>{title}</h3>
                    )}
                    {content && renderContent(content)}
                    {stringContent && (
                        <p className={'a-tooltip-element__description'}>
                            {stringContent}
                        </p>
                    )}
                </span>
            </div>
        </div>
    );
};

export default Tooltip;
